import { DesktopShell } from '@/components/dashboard/DashboardShell';
import { AttendanceContent } from '@/components/dashboard/AttendanceContent';

export default function AttendanceDesktop() {
  return <AttendanceContent Shell={DesktopShell} />;
}
